<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZinputTitle from '../../_common/z/zinput-title.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import Zframe from '../../_common/z/zframe.svelte'
    import type { Channel } from '../../../modules/brokerApi/channels/channel'
    import LoginFacebook from '../../_common/login-facebook.svelte'
    import LoginFacebookWaba from '../../_common/login-facebook-waba.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    const dispatch = createEventDispatcher()

    export let channelId: string

    let wabaPhoneID: string
    let wabaID: string
    let wabaBusinessID: string
    let wabaToken: string
    let step = 1
    let show = false

    let wabaData: { waba_id: string; phone_number_id: string; business_id: string } = null

    function goTyping() {
        step = 3
    }

    function onWabaData(ev) {
        wabaData = ev.detail
        wabaID = ev.detail.wabaID
        wabaPhoneID = ev.detail.wabaPhoneID
        wabaBusinessID = ev.detail.wabaBusinessID
        console.log('ev.detail', ev.detail)
    }

    async function onWabaConnected(ev) {
        const code = ev.detail.code
        console.log('code', code)
        try {
            show = true
            const result = await window.api.brokers.channels.wabaToken(channel.channelId, code)
            wabaToken = result.token
            const success = await goSave()
            // adiciona os templates padrão
            if (success) {
                try {
                    const result = await window.api.brokers.creatives.addDefaultTemplates(wabaID)
                } catch (error) {}
            }
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    let channel: Channel
    async function load() {
        channel = await window.api.brokers.channels.getOne(channelId)
        wabaPhoneID = channel?.externalId || ''
    }

    async function goSave() {
        if (!wabaPhoneID || !wabaToken || !wabaBusinessID || !wabaID) {
            alert('Nem todas as informações necessárias foram carregadas.')
            return
        }
        try {
            show = true
            const result = await window.api.brokers.channels.update(channelId, {
                credentials: { wabaBusinessID, wabaID, wabaPhoneID, token: wabaToken },
                externalId: wabaPhoneID, // necessário para o webhook
                token: wabaToken, // retrocomp
            })
            console.log(result)
            dispatch('connected')
            return true
        } catch (error) {
            return false
            window.error(error)
        } finally {
            show = false
        }
    }

    onMount(async () => {
        await load()
    })
</script>

<LoadSpinner {show}></LoadSpinner>
{#if step === 1}
    <div class="config-box m-4">
        <div class="d-flex flex-column align-items-center">
            <div class="subtitle mb-4">Escolha como pretende inserir suas credenciais</div>
            <!-- <Zbutton class="mb-2" grow={true} label="QR Code" on:click={goQRCode}></Zbutton> -->
            <LoginFacebookWaba appId="1588663558673618" configId="1593019025103214" on:waba-data={onWabaData} on:auth-success={onWabaConnected}
            ></LoginFacebookWaba>
            <div class="btn-type">
                <Zbutton class="mt-2" grow={true} label="Digitar credenciais" on:click={goTyping}></Zbutton>
            </div>
        </div>
    </div>
{/if}

{#if step === 3}
    <Zact>
        <Zbutton label="Voltar" on:click={() => (step = 1)}></Zbutton>
        <div class="spacer" />
        <Zbutton color="primary" icon={faSave} label="Salvar" on:click={goSave}></Zbutton>
    </Zact>
    <Zframe class="m-4">
        <ZContainer>
            <ZinputTitle title="Dados de sua BM" label=""></ZinputTitle>
            <Zinput
                help="Este é o ID é encontrado em sua BM (Identificação do portfólio empresarial): https://business.facebook.com/latest/settings/business_info"
                label="Meta Business ID (ID da BM)"
                size={12}
                type="text"
                required={true}
                bind:value={wabaBusinessID}
            ></Zinput>
            <Zinput
                help="Este ID WABA é encontrado no gerenciador do Whatsapp em sua BM: https://business.facebook.com/latest/whatsapp_manager"
                label="ID WABA"
                size={12}
                type="text"
                required={true}
                bind:value={wabaID}
            ></Zinput>
            <Zinput
                help="Este ID DO NÚMERO DE WHATSAPP é encontrado no gerenciador do Whatsapp em sua BM: https://business.facebook.com/latest/whatsapp_manager"
                label="ID do telefone"
                size={12}
                type="text"
                required={true}
                bind:value={wabaPhoneID}
            ></Zinput>
            <Zinput
                help="Um token de usuário do sistema com as permissões: whatsapp_business_management e whatsapp_business_messaging"
                label="Token do usuário (usuário do sistema)"
                size={12}
                type="text"
                required={true}
                bind:value={wabaToken}
            ></Zinput>
            {#if channel?.credentials?.token}
                <div class="alert alert-warning">
                    Atenção: já existe um token informado. Alterar o token fará com que o token anterior deixe de ser utilizado. (O token está oculto por
                    segurança)
                </div>
            {/if}
        </ZContainer>
    </Zframe>
{/if}

<style>
    .btn-type {
        max-width: 214px;
        width: 100%;
    }
</style>
